import React, {useEffect} from "react";
import { useUser } from "../ContextApi/UserContext";

export const Authenticate = () => {
    const { handleLogin } = useUser();
  
    useEffect(() => {
      handleLogin();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return(
        <>
        </>
    )
}